/**
 * Progress Steps Component
 * Displays the multi-step progress indicator
 */
import { Check } from "lucide-react";

const STEPS = [
  { num: 1, label: "Your Info" },
  { num: 2, label: "Services" },
  { num: 3, label: "Schedule" },
  { num: 4, label: "Review" },
];

export default function ProgressSteps({ currentStep }) {
  return (
    <div className="bg-white border-b border-slate-200 py-6">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center justify-between">
          {STEPS.map((step, idx) => (
            <div key={step.num} className="flex items-center">
              <div className="flex flex-col items-center">
                <div
                  className={`step-indicator ${
                    currentStep > step.num 
                      ? "completed" 
                      : currentStep === step.num 
                        ? "active" 
                        : "inactive"
                  }`}
                  data-testid={`step-indicator-${step.num}`}
                >
                  {currentStep > step.num ? <Check className="w-5 h-5" /> : step.num}
                </div>
                <span className={`text-xs mt-2 font-medium ${
                  currentStep >= step.num ? "text-slate-900" : "text-slate-400"
                }`}>
                  {step.label}
                </span>
              </div>
              {idx < STEPS.length - 1 && (
                <div className={`w-12 sm:w-20 h-1 mx-2 rounded ${
                  currentStep > step.num ? "bg-emerald-500" : "bg-slate-200"
                }`} />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
